import type { EChartsOption } from 'echarts';
import { EChart } from './EChart';

interface TreeNode {
  name: string;
  children?: TreeNode[];
  value?: number;
}

interface TreeChartProps {
  data: TreeNode[];
  height?: number | string;
  loading?: boolean;
}

export function TreeChart({ data, height, loading }: TreeChartProps) {
  const option: EChartsOption = {
    tooltip: { trigger: 'item' },
    series: [{ type: 'tree', data, top: '5%', bottom: '5%', left: '5%', right: '15%', symbolSize: 10, label: { position: 'left', verticalAlign: 'middle' }, leaves: { label: { position: 'right' } }, expandAndCollapse: true, animationDuration: 550 }],
  };
  return <EChart option={option} height={height} loading={loading} />;
}
